<template>
  <div id="app">
    <nut-menu/>
    <div class="container" v-if="!mobile_component">
      <div class="container container-fixed">
        <div class="position-relative">
        </div>
        <!--            <div class="next-page">-->
        <!--                <transition name="slide-fade">-->
        <!--                    <component :is="nextComponent"></component>-->
        <!--                </transition>-->
        <!--            </div>-->
        <!--            <div class="prev-page">-->
        <!--                <transition name="slide-fade">-->
        <!--                    <component :is="prevComponent"></component>-->
        <!--                </transition>-->
        <!--            </div>-->
      </div>
    </div>
    <transition :name="transitionName">
      <keep-alive>
        <router-view class="height-400" :mobile_component="mobile_component" @showBuyNow="buy_now=true"
                     @hideBuyNow="buy_now=false"/>
      </keep-alive>
    </transition>


    <div class="container" v-show="$route.meta.index==3 ||$route.meta.index==0 ||(($route.meta.index==1) &&!buy_now)">
      <div class="container container-fixed-bottom">
        <div class="position-relative">
          <div class="ask-q-fixed" @mouseover="askHover = true" @mouseleave="askHover = false" :class="{ active: askHover }">
            <a href="https://www.aptanutricia.ro/intreaba-expertii" id="question">
              <img src="./assets/images/icon-hover.png" alt="">
              <p>Întreabă experții</p>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-show="$route.meta.index==2">
      <div class="container container-fixed-bottom">
        <div class="position-relative">
          <div class="mcn-footer-buy">
            <a href="#" @click="goToCumpara()">CUMPARA ACUM</a>
          </div>
        </div>
      </div>
    </div>
    <nut-footer/>


    <div class="dropdown-menu filter-dropdown-menu hide-buy" id="buy1"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-praf-aptamil-pronutra-incepand-de-la-12-luni-800-g-nutricia" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-1-1-2-ani-800-g-aptamil-p217094" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-1-cu-pronutra-formula-de-lapte-de-crestere-premium-1-2-ani-800-g-nutricia-i5520.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/aptamil-nutri-biotik-1-lapte-pentru-copii-1-2-ani-800-g.html?_gl=1*plz9mt*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAw5W-BhAhEiwApv4goGYkxrilWnJg8UG6d46ngFBeJSLlD58E0m_itD7BHpTRZEav1dXfhBoCiBEQAvD_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-junior-1-x-800-g-62606.html?_gl=1*rcx3bu*_up*MQ..&gclid=EAIaIQobChMI5JT90d2tiAMVUpGDBx2JehpjEAAYASAAEgKpS_D_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-1-800-g-1-2-ani-nutricia-569099/pd/D17GXBBBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu filter-dropdown-menu hide-buy" id="buy2"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="miababy">
        <a href="https://www.miababy.ro/lapte-praf-nutricia-aptamil-junior-2-800g-2ani-607464" target="_blank">
          <img src="./assets/images/pentru-imunitate/miababy.png" alt="">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-ardealul">
        <a href="https://www.farmaciaardealul.ro/noul-aptamil-2-lapte-praf-pentru-copii-de-varsta-mica-800-gr-2-ani-649"
           target="_blank">
          <img src="./assets/images/pentru-imunitate/ardealul.png" alt="">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="mattca">
        <a href="https://www.mattca.ro/aptamil-2-lapte-praf-pentru-copii-de-varsta-mica-800-gr-2-ani#.YAGom-gzY2w"
           target="_blank">
          <img src="./assets/images/pentru-imunitate/mattca.png" alt="">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-nutricia-aptamil-junior-2-800-g-24-36-luni-560139/pd/DQ7GXBBBM/?X-Search-Id=5cebe611e5b6c6a576a9&X-Product-Id=313832&X-Search-Page=1&X-Search-Position=6&X-Section=search&X-MB=0&X-Search-Action=view"
           target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="">
        </a>
      </button>
    </div>
    <div class="dropdown-menu filter-dropdown-menu hide-buy" id="buy3"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="miababy">
        <a href="https://www.miababy.ro/lapte-praf-nutricia-aptamil-junior-3-800g-3ani-591029" target="_blank">
          <img src="./assets/images/pentru-imunitate/miababy.png" alt="">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-ardealul">
        <a href="https://www.farmaciaardealul.ro/nutricia-lapte-praf-pentru-bebelusi-aptamil-junior-3-800gr"
           target="_blank">
          <img src="./assets/images/pentru-imunitate/ardealul.png" alt="">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="mattca">
        <a href="https://www.mattca.ro/aptamil-junior-3-lapte-praf-pentru-copii-de-varsta-mica-800-gr-3-ani#.YAGonugzY2w"
           target="_blank">
          <img src="./assets/images/pentru-imunitate/mattca.png" alt="">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-nutricia-aptamil-junior-3-800-g-de-la-3-ani-574635/pd/DR7GXBBBM/?X-Search-Id=5cebe611e5b6c6a576a9&X-Product-Id=313833&X-Search-Page=1&X-Search-Position=5&X-Section=search&X-MB=0&X-Search-Action=view"
           target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="">
        </a>
      </button>
    </div>
    <div class="dropdown-menu filter-dropdown-menu hide-buy" id="buy4"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-praf-aptamil-1-incepand-de-la-nastere-800-g-nutricia" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe-si-copii/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-1-0-6-luni-800-g-aptamil-p218921" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-1-cu-pronutra-formula-de-lapte-de-continuare-premium-0-luni-800-g-nutricia-i5507.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/aptamil-1-lapte-de-inceput-800-g-0-6-luni.html?_gl=1*1th79t*_up*MQ..*_gs*MQ.." target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-1-x-800-g-62871.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-nutricia-aptamil-1-800-g-0-6-luni-121293/pd/DS7GXBBBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu filter-dropdown-menu hide-buy" id="buy5"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-praf-aptamil-2-incepand-de-la-6-luni-800-g-nutricia" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe-si-copii/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-de-continuare-nutri-biotik-2-6-12-luni-800-g-aptamil-p217092" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-2-cu-pronutra-formula-de-lapte-de-continuare-premium-6-12-luni-800-g-nutricia-i5510.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/aptamil-nutri-biotik-2-lapte-de-continuare-800-g-6-12-luni.html?_gl=1*1th79t*_up*MQ..*_gs*MQ.." target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-2-x-800-g-62800.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-nutricia-aptamil-2-800-g-6-12-luni-120356/pd/DL7GXBBBM/?path=lapte-praf-nutricia-aptamil-2-800-g-6-12-luni-120356/pd/DL7GXBBBM" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>

    <div class="dropdown-menu2 filter-dropdown-menu hide-buy" id="buy6"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-praf-aptamil-pronutra-incepand-de-la-12-luni-800-g-nutricia" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-1-1-2-ani-800-g-aptamil-p217094" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-1-cu-pronutra-formula-de-lapte-de-crestere-premium-1-2-ani-800-g-nutricia-i5520.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/aptamil-nutri-biotik-1-lapte-pentru-copii-1-2-ani-800-g.html?_gl=1*plz9mt*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAw5W-BhAhEiwApv4goGYkxrilWnJg8UG6d46ngFBeJSLlD58E0m_itD7BHpTRZEav1dXfhBoCiBEQAvD_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-junior-1-x-800-g-62606.html?_gl=1*rcx3bu*_up*MQ..&gclid=EAIaIQobChMI5JT90d2tiAMVUpGDBx2JehpjEAAYASAAEgKpS_D_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-1-800-g-1-2-ani-nutricia-569099/pd/D17GXBBBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu2 filter-dropdown-menu hide-buy" id="buy7"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-praf-aptamil-junior-pronutra-incepand-de-la-2-ani-800-g-nutricia" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-2-2-3-ani-800-g-aptamil-p217438" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-junior-2-cu-pronutra-formula-de-lapte-de-crestere-premium-2-3-ani-800-g-nutricia-i5518.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/aptamil-nutri-biotik-2-lapte-pentru-copii-2-ani-800-g.html?_gl=1*plz9mt*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAw5W-BhAhEiwApv4goGYkxrilWnJg8UG6d46ngFBeJSLlD58E0m_itD7BHpTRZEav1dXfhBoCiBEQAvD_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-junior-2-x-800-g-62636.html?_gl=1*rcx3bu*_up*MQ..&gclid=EAIaIQobChMI5JT90d2tiAMVUpGDBx2JehpjEAAYASAAEgKpS_D_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-2-800-g-2-3-ani-nutricia-560139/pd/DQ7GXBBBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu2 filter-dropdown-menu hide-buy" id="buy8"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-praf-aptamil-junior-3-800g-nutricia" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-3-peste-3-ani-800-g-aptamil-p218093" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-junior-3-cu-pronutra-formula-de-lapte-de-crestere-premium-3-ani-800-g-nutricia-i5519.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/lapte-praf-aptamil-junior-3-36-luni-800g.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-junior-3-x-800-g-62637.html?_gl=1*rcx3bu*_up*MQ..&gclid=EAIaIQobChMI5JT90d2tiAMVUpGDBx2JehpjEAAYASAAEgKpS_D_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-3-800-g-de-la-3-ani-nutricia-574635/pd/DR7GXBBBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu2 filter-dropdown-menu hide-buy" id="buy9"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-premium-pentru-copii-de-varsta-mica-1-2-ani-nutri-biotik-1-1200g-aptamil" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-1-1-2-ani-1200-g-aptamil-p97105" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-junior-1-1200-g-p479849226.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/lapte-praf-nutri-biotik-1-1-2-ani-1200-g-aptamil.html?_gl=1*plz9mt*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAw5W-BhAhEiwApv4goGYkxrilWnJg8UG6d46ngFBeJSLlD58E0m_itD7BHpTRZEav1dXfhBoCiBEQAvD_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-junior-1-x-1200-g-62638.html?_gl=1*rcx3bu*_up*MQ..&gclid=EAIaIQobChMI5JT90d2tiAMVUpGDBx2JehpjEAAYASAAEgKpS_D_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-1-1-200-g-1-2-ani-nutricia-5900852050688/pd/D6ZC7DMBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu2 filter-dropdown-menu hide-buy" id="buy10"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-premium-pentru-copii-de-varsta-mica-2-3-ani-nutri-biotik-2-1200g-aptamil" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-2-2-3-ani-1200-g-aptamil-p369426" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-junior-2-1200-g-p479849227.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/lapte-praf-nutri-biotik-2-2-3-ani-1200-g-aptamil.html?_gl=1*plz9mt*_up*MQ..*_gs*MQ..&gclid=CjwKCAiAw5W-BhAhEiwApv4goGYkxrilWnJg8UG6d46ngFBeJSLlD58E0m_itD7BHpTRZEav1dXfhBoCiBEQAvD_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-junior-2-x-1200-g-62639.html?_gl=1*rcx3bu*_up*MQ..&gclid=EAIaIQobChMI5JT90d2tiAMVUpGDBx2JehpjEAAYASAAEgKpS_D_BwE" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-2-1-200-g-2-3-ani-nutricia-5900852050701/pd/D8ZC7DMBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu2 filter-dropdown-menu hide-buy" id="buy11"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-de-inceput-pentru-0-6-luni-nutri-biotik-1-1200g-aptamil" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe-si-copii/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-1-0-6-luni-1200-g-aptamil-p418049" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-1-nutri-biotik-0-6-luni-1200g-nutricia-p548491403.html?ref=search_page" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/lapte-praf-nutri-biotik-1-0-6-luni-1200-g-aptamil.html?_gl=1*1th79t*_up*MQ..*_gs*MQ.." target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-1-x-1200-g-77578.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-1-1200-g-0-6-luni-nutricia-5900852060625/pd/D2P4YHYBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
    <div class="dropdown-menu2 filter-dropdown-menu hide-buy" id="buy12"
         style="position: absolute; transform: translate3d(0px, 50px, 0px); ">
      <button class="btn buy-from" @click="buyNow($event)" data-market="dr-max">
        <a href="https://www.drmax.ro/lapte-de-inceput-pentru-6-12-luni-nutri-biotik-2-1200g-aptamil" target="_blank">
          <img src="./assets/images/pentru-imunitate/dr-max.png" alt="Dr Max">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="bebe-tei">
        <a href="https://comenzi.bebetei.ro/hrana-bebe-si-copii/formule-lapte-praf-bebe/formule-lapte-praf-de-crestere/lapte-praf-nutri-biotik-2-1200-g-6-12-luni-aptamil-p418048" target="_blank">
          <img src="./assets/images/pentru-imunitate/bebe-tei.png" alt="Bebe Tei">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="farmacia-dav">
        <a href="https://www.farmaciiledav.ro/mama-si-copilul/lapte-si-mancare/formule-lapte/aptamil-2-nutri-biotik-6-12-luni-1200g-nutricia-p548491404.html?ref=search_page" target="_blank">
          <img src="./assets/images/pentru-imunitate/farmacia-dav.jpg" alt="Farmacia Dav">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="spring">
        <a href="https://www.springfarma.com/lapte-praf-nutri-biotik-2-6-12-luni-1200-g-aptamil.html?_gl=1*1th79t*_up*MQ..*_gs*MQ.." target="_blank">
          <img src="./assets/images/pentru-imunitate/spring.png" alt="Spring">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="minifarm">
        <a href="https://www.minifarmonline.ro/lapte-praf/c/lapte-praf-aptamil-nutri-biotik-2-x-1200-g-77579.html" target="_blank">
          <img src="./assets/images/pentru-imunitate/minifarm.png" alt="Minifarm">
        </a>
      </button>
      <button class="btn buy-from" @click="buyNow($event)" data-market="emag">
        <a href="https://www.emag.ro/lapte-praf-aptamil-nutri-biotik-2-1200-g-6-12-luni-nutricia-5900852060632/pd/D7P4YHYBM/" target="_blank">
          <img src="./assets/images/pentru-imunitate/emag.png" alt="eMag">
        </a>
      </button>
    </div>
  </div>
</template>

<script>
import Menu from './components/Menu2.vue'
import Footer from './components/Footer.vue'
import Imunitate from './views/Imunitate';
import SecreteleLaptelui from './views/SecreteleLaptelui';
import PreparareFormule from './views/PreparareFormule';
import FormuleAptamil from './views/FormuleAptamil';

export default {
  components: {
    'nut-menu': Menu,
    'nut-footer': Footer,
  },
  data() {
    return {
      transitionName: '',
      windowWidth: 0,
      mobile_component: false,
      prevComponent: null,
      buy_now: false,
      nextComponent: Imunitate,
      askHover: false,
    }
  },
  watch: { //Use watch to monitor changes in $router
    $route(to, from) {
      switch (to.name) {
        case 'SecreteleLaptelui':
          this.prevComponent = null;
          this.nextComponent = Imunitate;
          break;

        case 'Imunitate':
          this.prevComponent = SecreteleLaptelui;
          this.nextComponent = FormuleAptamil;
          break;

        case 'FormuleAptamil':
          this.prevComponent = Imunitate;
          this.nextComponent = PreparareFormule;
          break;

        case 'PreparareFormule':
          this.prevComponent = FormuleAptamil;
          this.nextComponent = null;
          break;
      }

      if (to.params.top) {
        // daca e top menu sa faca urmatoarea tranzitie
        this.transitionName = 'fade-in-out';
      } else {
        //If the to index is larger than the from index, it is judged to be in the forward state, and vice versa, in the backward state.
        if (to.meta.index > from.meta.index) {
          //Setting Animation Name
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }

      }
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    }
  },
  mounted() {
    switch (this.$route.name) {
      case 'SecreteleLaptelui':
        this.prevComponent = null;
        this.nextComponent = Imunitate;
        break;

      case 'Imunitate':
        this.prevComponent = SecreteleLaptelui;
        this.nextComponent = FormuleAptamil;
        break;

      case 'FormuleAptamil':
        this.prevComponent = Imunitate;
        this.nextComponent = PreparareFormule;
        break;

      case 'PreparareFormule':
        this.prevComponent = FormuleAptamil;
        this.nextComponent = null;
        break;
    }
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth);
      //Init
      this.getWindowWidth()
    })

    document.addEventListener('click', function (event) {
      if (!event.target.classList.contains('cumpara-prin')) {
        var list = document.getElementsByClassName('dropdown-menu');
        for (var i = 0; i < list.length; i++) {
          if (list[i] !== undefined) {
            list[i].classList.remove("show-buy");
          }
        }

        var list2 = document.getElementsByClassName('cumpara-prin');
        for (i = 0; i < list.length; i++) {
          if (list2[i] !== undefined) {
            list2[i].classList.remove("open");
          }
        }

        var list3 = document.getElementsByClassName('dropdown-menu2');
        for (i = 0; i < list3.length; i++) {
          if (list3[i] !== undefined) {
            list3[i].classList.remove("show-buy");
          }
        }
      }
    });
  },
  methods: {
    getWindowWidth() {
      this.mobile_component = window.innerWidth < 992;
      this.windowWidth = window.innerWidth;
    },
    goTo() {
      window.fbq('track', 'Intreaba-Expertii');
      window.gtag('event', 'sent', {'event_category': 'buton-intreaba-expertii'});
      window.open("https://www.aptanutricia.ro/descopera-stiinta-nutricia/mamicile-intreaba", '_blank');
    },
    goToCumpara() {
      window.fbq('track', 'Comanda-Acum');
      window.gtag('event', 'click', {'event_category': 'buton-cumpara-acum'});

      window.open("https://www.emag.ro/lapte-praf-bebelusi/brand/nutricia/c?ref=bc", '_blank');
    },
    buyNow: function(event) {
      var market = event.currentTarget.getAttribute('data-market');

      if (market === 'miababy') {
        window.gtag('event', 'click', {'event_category': 'nutri-miababy'});
      }
      if (market === 'farmacia-ardealul') {
        window.gtag('event', 'click', { 'event_category': 'nutri-farmacia-ardealul' });
      }
      if (market === 'mattca') {
        window.gtag('event', 'click', { 'event_category': 'nutri-mattca' });
      }
      if (market === 'emag') {
        window.gtag('event', 'click', { 'event_category': 'nutri-emag' });
      }

      window.gtag('event', 'click', {'event_category': 'buton-cumpara-acum'});
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  }
}
</script>
<style lang="scss">
.mobile-banner {
  width: 100%;
  display: flex;
  overflow-x: hidden;
  overflow-y: hidden;

  .main-page-banner {
    width: 100%;
  }

  .next-page-banner {
    opacity: 0.2;
    width: 10%;

    .nut-banner {
      width: fit-content;
    }
  }
}
</style>
<style>
#app {
  overflow: hidden;
}

#app iframe {
  max-width: 100%;
}

.container-fixed {
  padding-top: 30px;
}

.ask-q-fixed {
  background: #029FE3;
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  position: fixed;
  bottom: 30px;
  right: 9%;
  z-index: 99;
  cursor: pointer;
}

.ask-q-fixed.active {
  width: 240px;
}

.ask-q-fixed.active p {
  display: block;
  margin-left: 10px;
}

.ask-q-fixed p {
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  display: none;
  margin-bottom: 0;
}

.ask-q-fixed:hover, .ask-q-fixed {
  transition: all 0.25s linear;
}

.ask-q-fixed:hover {
  background: #17479E;
}

.ask-q-fixed a {
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  white-space: nowrap;
}

#nav {
  height: 30px;
  background-color: red;
}

body {
  font-family: 'Montserrat', sans-serif;
}

h1 {
  font-size: 40px;
  font-weight: 900;
  color: #17479E;
}

.height-400 {
  min-height: 400px;
}

.slide-fade-enter-active {
  transition: all 2.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.02s linear;
}

.slide-fade-enter,
.slide-fade-leave-to

  /* .slide-fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}


.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.25s;
  transition-property: opacity, transform;
  /*transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);*/
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;

}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;

}


h1 {
  font-size: 40px;
  font-weight: 900;
  color: #17479E;
}

p {
  font-size: 16px;
  font-weight: 400;
  color: #17479E;
}

section {
  margin: 0;
}

.mcn-footer {
  width: inherit;

}

.mcn-footer a {
  position: absolute;
  bottom: 0;
  text-align: center;
  margin: 0 0 10px 20px;
  z-index: 99;
  right: 0;
  background: #029FE3;
  border-radius: 50%;
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.mcn-footer a:hover {
  width: 260px;
  height: 67px;
  text-decoration: none;
  border-radius: 45px;
  padding-top: 18px;
  transition: all 0.1s ease;
  background: #17479E;
  color: #fff;
}

.mcn-footer a:hover:after {

  color: #fff;
  margin-left: 15px;
  font-weight: 700;
  font-size: 16px;
  transition: all 0.1s ease;
}

.container-fixed {
  position: absolute;
  top: 100px;
  width: 100%;
  z-index: 9;
}

.container-fixed .arrow-right {
  position: absolute;
  right: -25px;
  z-index: 15;
  cursor: pointer;
}

.container-fixed .arrow-left {
  position: absolute;
  right: 99%;
  z-index: 15;
  cursor: pointer;
}

.container-fixed-bottom {
  position: fixed;
  bottom: 50px;
  width: 100%;
  z-index: 10;

}

.main-banner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.next-page {
  left: 98%;
  position: absolute;
  top: -50px;
  z-index: -1;
  opacity: 0.2;
  width: fit-content;
  width: -moz-max-content;
}

.single-arrow .arrow-right {
  left: 93%;
}


.next-page .arrow-left {
  display: none;
}

.next-page .arrow-right {
  display: none;
}

.prev-page .arrow-right {
  display: none;
}

.next-page .arrow-left {
  display: none;
}

.prev-page {
  right: 100%;
  position: absolute;
  top: -50px;
  z-index: -1;
  opacity: 0.2;
  width: fit-content;
  width: -moz-max-content;
}

.mcn-footer-buy {
  display: none;
}

@media only screen and (max-width: 992px) {
  h2, h1 {
    font-size: 26px;
    line-height: 30px;
  }

  section {
    margin: 0 !important;
  }

  .container-fixed {
    position: fixed;
  }

  .container-fixed .arrow-left {
    position: absolute;
    right: 0px;
    left: auto;
    z-index: 15;
    top: 70px;
  }

  .container-fixed .arrow-right {
    position: absolute;
    right: 0;
    z-index: 15;
  }

  .mcn-footer-buy {
    display: none;
  }

  .mcn-footer-buy a {
    position: absolute;
    bottom: 0;
    text-align: center;
    margin: 0 0 10px 20px;
    width: 100%;
    height: 52px;
    padding: 15px 0 5px 0;
    z-index: 99;
    display: block;
    right: 15px;
    background: #029FE3;
    border-radius: 45px;
    text-decoration: none;
    color: #fff;
    font-weight: 700;
    font-size: 16px;

  }

  .pt-30 {
    padding: 0;
    text-align: center;
  }

  .pb-30 {
    padding-bottom: 30px;
  }

  .more-mobil {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    border: 1px solid #009FE3;
    border-radius: 25px;
    width: 100%;
    height: 50px;
    margin-top: 15px;
    background: #009FE3;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .more-mobil:hover {
    text-decoration: none;
    color: white;
  }

}

@media only screen and (max-width: 768px) {

  .container-fixed-bottom {
    bottom: 15px;
  }

  .single-arrow .arrow-left,
  .single-arrow .arrow-right {
    right: -41px;
  }

  .mcn-footer a {
    position: absolute;
    bottom: 0;
    text-align: center;
    margin: 0;
    width: 52px;
    height: 52px;
    padding: 8px 0 5px 0;
    z-index: 99;
    display: block;
    right: 15px;
    background: #029FE3;
    border-radius: 45px;
  }


  .next-page {
    display: none;
    right: -72%;
  }

  .prev-page {
    display: none;
    left: -80%;
  }


  .mcn-footer a:hover {
    width: 260px;
    height: 67px;
    text-decoration: none;
    border-radius: 45px;
    padding-top: 18px;
    transition: all 0.1s ease;
  }

  .mcn-footer a:after {
    text-transform: uppercase;
    color: #fff;
    margin-left: 15px;
    font-weight: 700;
    font-size: 16px;
    transition: all 0.1s ease;
    margin-top: 6px;
    display: flex;
    justify-content: center;
  }

  .container-fixed .arrow-left {
    top: 50px;
  }
}

@media only screen and (max-width: 768px) {
  .container-fixed .arrow-left, .container-fixed .arrow-right {
    right: 15px;
  }

  #app iframe {
    width: 100%;
    height: 300px;
  }

  .produse .pt-5 {
    margin: 0px -30px;
  }

  .container-fixed .arrow-left,
  .container-fixed .arrow-right {
    height: 60px;
    /*right: 15px;*/
  }

  .container-fixed .arrow-left {
    top: 50px;
  }
}


@media only screen and (max-width: 450px) {
  .mcn-footer a {
    margin: 0 0 10px 10px;
  }

  #app iframe {
    height: 200px;
  }

  .container-fixed {
    padding-top: initial;
  }
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #17479E !important;
  width: 36px;
}

.owl-theme .owl-dots .owl-dot span {
  background: #C4E4F9 !important;
}

.owl-theme .owl-dots .owl-dot {
  outline: none !important;
}

.owl-theme .owl-dots .owl-dot span {
  transition: all .25s ease-in-out !important;
}

.owl-carousel .owl-stage-outer .owl-stage{
  padding-left: 0 !important;
}
</style>
